import QueryContext from '../QueryContext';
import api from '../index';

export const DEFAULT_CONTENT_SUBMISSION_INCLUDE = [
  'profile',
  'versions.content_submission_comments',
  'versions.approvals',
  'child_content_submissions.versions.content_submission_comments',
  'child_content_submissions.versions.approvals',
  'campaign.brand',
  'campaign.campaign_approval_steps',
];

const contentSubmissionFetchers = {
  contentSubmission: (context: QueryContext) =>
    api.get(`/content_submissions/${context.meta?.contentSubmissionId}`, {
      params: {
        include:
          (context.meta?.include as string[]) ??
          DEFAULT_CONTENT_SUBMISSION_INCLUDE,
      },
    }),
  contentSubmissionVersion: (context: QueryContext) =>
    api.get(
      `/content_submission_versions/${context.meta?.contentSubmissionVersionId}`,
      {
        params: {
          include: [
            'profile.identities',
            'content_submission_analysis',
            'content_submission.campaign',
          ],
        },
      }
    ),
};

export default contentSubmissionFetchers;
